import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { useEffect, useState } from 'react';
import { checkValidForm } from './Step1';
import BtnSave from './BtnSave';

const Step7 = (props) => {
    const { t } = useTranslation();

    const [haveError, setHaveError] = useState(false);

    const onNextStep = () => {
        if (props.passStep) {
            props.nextStep();
            props?.form
                .validateFields()
                .then(() => {
                    props.setStep7(true);
                    setHaveError(false);
                })
                .catch(() => {
                    props.setStep7(false);
                    setHaveError(true);
                });
        } else {
            setHaveError(true);
        }
    };

    useEffect(() => {
        if (props.passStep) {
            setHaveError(false);
        }
    }, [props.passStep]);

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.dataController) {
            onValuesChange(null, props.previewData?.dataController);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = ['contactChannelTh'];
        const check = checkValidForm(fields, allValues);
        props.setStep7(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('policy.des7')}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="dataController"
                layout="vertical"
                form={props?.form}
            >
                <Form.Item
                    className="mt-4"
                    name={'contactChannelTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.contactChannelTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'contactChannelEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.contactChannelEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodEnPl')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('Preview before publishing')}{' '}
                            <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                    {haveError && (
                        <div className="text-red-500 space-x-2 mt-2">
                            <InfoCircleOutlined />
                            <span>
                                {t(
                                    'Unable to preview before release Please complete the required information on each tab'
                                )}
                            </span>
                        </div>
                    )}
                </Sticky>
            </Form>
        </div>
    );
};

export default Step7;
